import { CaretDown } from "@phosphor-icons/react"
import { Button, Menu, MenuItem, Popover, Toast } from "@vesatogo/grass-core"
import { useReportModal } from "@vesatogo/grass-reportmodal"
import { isEmpty } from "lodash-es"
import { useState } from "react"
import toast from "react-hot-toast"
import { useSearchParams } from "react-router-dom"
import { useClient } from "urql"
import { useAuthorization } from "~/components/AuthorizationProvider"
import { openDeleteTradesConfirm } from "~/components/DeleteTradesConfirm"
import PayableImporter from "~/components/PayableReceivableImporter"
import GenerateTripModal from "~/components/VehicleConsolidation/GenerateTripModal"
import { TradeKinds } from "~/constants/Kinds"
import { Permission } from "~/constants/Permissions"
import { APIRoutes } from "~/constants/routes"
import {
  useAllDepartmentsQuery,
  useAuthenticatedUserQuery,
} from "~/generated/graphql"
import { TRADES_HASHES } from "~/graphql/trade.gql"
import { useTradeSelectorList } from "~/store/trade-selector.store"
// import { useDumpTrades } from "~/utils/useDumpTrades"
const TradeActions = () => {
  const [params, setParams] = useSearchParams()
  const onOpen = useReportModal(store => store.onOpen)

  const [isImporterOpen, setImporterOpen] = useState("")
  const [isGenerateTripOpen, setGenerateTripOpen] = useState(false)

  const client = useClient()
  const [{ data: me }] = useAuthenticatedUserQuery()
  const { selected, setSelected, reset } = useTradeSelectorList()

  const bookingPattiList = Object.values(selected)?.filter(
    val => val?.kind === TradeKinds.Booking
  )
  const notBookingPattiList = Object.values(selected)?.filter(
    val => val?.kind !== TradeKinds.Booking
  )

  const shareViaWhatsApp = async ({ type = "buyer" }) => {
    const ids = Object.values(selected)?.map(trade => trade?.id)

    if (isEmpty(ids)) return

    const { data } = await client
      .query(TRADES_HASHES, {
        ids,
      })
      .toPromise()

    const tradeHashes = data?.trade || []

    tradeHashes?.forEach(async trade => {
      const id = type === "buyer" ? trade?.buyer_hash : trade?.seller_hash
      if (!id) return
      const url = `https://${
        import.meta.env.VITE_REST_URL
      }/${APIRoutes.whatsAppTradeReceipt(id)}`

      const token = localStorage.getItem("token")

      const response = await fetch(url, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      if (!response.ok)
        toast.custom(
          <Toast title={"Unable to send to WhatsApp!"} intent="danger" />
        )
      else toast.custom(<Toast title="Message will be sent!" />)
    })
  }

  const canShareViaWhatsApp = useAuthorization(
    Permission.canSendTradeReceiptsViaWhatsApp
  )
  const canSendMISReport = useAuthorization(Permission.canSendMISReport)
  const canDeleteTrades = useAuthorization(Permission.CanDeleteTrades)

  // const dumpTrades = useDumpTrades()

  const draftTrades = Object.values(selected)
    ?.filter(trade => trade?.current_status_id === "Draft")
    ?.map(trade => trade?.id)
    ?.filter(Boolean)

  // const deleteTrades = async () => {
  //   const isDeleted = await dumpTrades(draftTrades)
  //   if (!isDeleted) return
  //   reset()
  //   params.set("updatedAt", Date.now().toString())
  //   setParams(params)
  // }

  return (
    <>
      <Popover
        minimal
        arrow={false}
        className="p-0"
        trigger="click"
        interactive
        animation="fade"
        theme="light-border"
        placement="bottom"
        content={
          <Menu className="max-h-fit !text-sm">
            <div className="text-gray-800 font-600 p-2 underline">Report</div>
            <MenuItem
              onClick={() => {
                onOpen(
                  [
                    {
                      key: "from_date",
                      label: "Date From",
                      type: "date",
                    },
                    {
                      key: "till_date",
                      label: "Date Till",
                      type: "date",
                    },
                    {
                      key: "trade_role",
                      label: "Trade Role",
                      type: "staticSelect",
                      options: [
                        {
                          id: "seller",
                          name: "Supplier",
                        },
                        {
                          id: "buyer",
                          name: "Buyer",
                        },
                      ],
                    },
                    {
                      key: "trade_kind",
                      label: "Trade Kind",
                      type: "staticSelect",
                      options: Object.entries(TradeKinds)?.map(
                        ([key, value]) => ({
                          id: value,
                          name: key,
                        })
                      ),
                    },
                    {
                      key: "department",
                      label: "Department",
                      type: "querySelect",
                      dataHook: useAllDepartmentsQuery,
                      variables: () => {
                        return {
                          where: {
                            company: {
                              organisation_id: {
                                _eq: me?.me?.agent?.organisation?.id,
                              },
                            },
                          },
                        }
                      },
                    },
                  ],
                  `https://${
                    import.meta.env.VITE_REST_URL
                  }/reports/trade_email/`,
                  {
                    multipleEmails: true,
                  }
                )
              }}
            >
              Trade Report
            </MenuItem>
            <MenuItem
              hidden={!canSendMISReport}
              onClick={() => {
                onOpen(
                  [
                    {
                      key: "from_date",
                      label: "Date",
                      type: "date",
                    },
                    {
                      key: "payable_report_name",
                      label: "MIS Report Name",
                      placeholder: "Select MIS Report Name",
                      type: "staticSelect",
                      options: [
                        {
                          id: "profit_loss_report",
                          name: "Profit & Loss Report",
                        },
                        {
                          id: "booking_patti_report",
                          name: "Open Transit Patti Report",
                        },
                        {
                          id: "sales_summary_report",
                          name: "Sales Summary Report",
                        },
                        {
                          id: "payment_collection_report",
                          name: "Payment Collection Report",
                        },
                        {
                          id: "outstanding_payment_report",
                          name: "Outstanding Payment Report",
                        },
                      ],
                    },
                  ],
                  `https://${
                    import.meta.env.VITE_REST_URL
                  }/reports/payable_receivable_report_email/`,
                  {
                    multipleEmails: true,
                  }
                )
              }}
            >
              MIS Report
            </MenuItem>
            <hr />
            <div className="text-gray-800 font-600 p-2 underline">Trades</div>
            <MenuItem
              onClick={() => {
                params.set("update", "all")
                setParams(params)
              }}
            >
              Update Trades
            </MenuItem>
            <MenuItem
              onClick={() => {
                params.set("action", "generate-invoice")
                setParams(params)
              }}
            >
              Generate Invoice For Buyer
            </MenuItem>
            <hr />
            <div className="text-gray-800 font-600 p-2 underline">Importer</div>
            <MenuItem onClick={() => setImporterOpen("booking_patti")}>
              Transit Patti Importer
            </MenuItem>
            <MenuItem onClick={() => setImporterOpen("hishob_patti")}>
              Hishob Patti Importer
            </MenuItem>

            <hr />
            {canShareViaWhatsApp && (
              <>
                <div className="text-gray-800 font-600 p-2 underline">
                  Share Receipt via WhatsApp
                </div>
                <MenuItem onClick={shareViaWhatsApp}>Share to Buyer</MenuItem>
                <MenuItem
                  onClick={() =>
                    shareViaWhatsApp({
                      type: "seller",
                    })
                  }
                >
                  Share to Supplier
                </MenuItem>
                <hr />
              </>
            )}
            <div className="text-gray-800 font-600 p-2 underline">Other</div>
            <MenuItem
              disabled={bookingPattiList?.length === 0}
              onClick={() => {
                if (notBookingPattiList?.length !== 0) {
                  for (const i of notBookingPattiList) {
                    setSelected({ id: i?.id })
                  }
                }
                setGenerateTripOpen(true)
              }}
            >
              Generate Trip
            </MenuItem>
            {/* <MenuItem
              intent="danger"
              hidden={!canDeleteTrades}
              disabled={isEmpty(draftTrades)}
              // onClick={() => {
              //   openDeleteTradesConfirm({
              //     tradeIds: draftTrades,
              //     onSubmit: deleteTrades,
              //   })
              // }}
            >
              Delete Trades
            </MenuItem> */}
          </Menu>
        }
      >
        <Button
          className="!bg-gray-300 text-sm leading-5 px-3 py-[6px] h-8 md:text-base md:leading-6 md:px-4 md:py-2 md:h-10"
          intent="none"
          leftIcon={<CaretDown weight="fill" />}
        >
          Action
        </Button>
      </Popover>
      {isImporterOpen && (
        <PayableImporter
          isOpen={!isEmpty(isImporterOpen)}
          onClose={() => setImporterOpen("")}
          title={`${
            isImporterOpen === "booking_patti" ? "Transit" : "Hishob"
          } Patti Importer`}
          loaderType={
            isImporterOpen === "booking_patti"
              ? "booking_patti"
              : "hishob_patti"
          }
        />
      )}

      {isGenerateTripOpen && (
        <GenerateTripModal
          isOpen={isGenerateTripOpen}
          onClose={() => setGenerateTripOpen(false)}
        />
      )}
    </>
  )
}

export default TradeActions
